import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../actions/application";
import { APPLICATION_CONTEXTS } from "../../constants";
import ImageText from "../common/imageText";
import NavigationBar from "../common/navigationBar";

class CareTeamDetail extends Component {
  /**************
   * Properties *
   **************/
  state = {
    currentPatient: this.props.currentPatient,
    careTeamMembers: {
      default: {
        careTeam1: {
          index: 0,
          pages: [require("./images/1274_CareTeam_bio1.png")],
        },
        careTeam2: {
          index: 1,
          pages: [require("./images/1274_CareTeam_bio2.png")],
        },
        careTeam3: {
          index: 2,
          pages: [require("./images/1274_CareTeam_bio3.png")],
        },
      },
      orthoPatient: {
        careTeam1: {
          index: 0,
          pages: [require("./images/1274_CareTeam_bio1.png")],
        },
        careTeam2: {
          index: 1,
          pages: [require("./images/1274_CareTeam_bio2.png")],
        },
        careTeam3: {
          index: 2,
          pages: [require("./images/1274_CareTeam_bio3.png")],
        },
      },
      chfPatient: {
        careTeam4: {
          index: 0,
          pages: [require("./images/1274_CareTeam_bio4.png")],
        },
        careTeam5: {
          index: 1,
          pages: [require("./images/1274_CareTeam_bio5.png")],
        },
        careTeam6: {
          index: 2,
          pages: [require("./images/1274_CareTeam_bio6.png")],
        },
        careTeam7: {
          index: 3,
          pages: [require("./images/1274_CareTeam_bio7.png")],
        },
      },
      pediatricPatient: {
        careTeam8: {
          index: 0,
          pages: [require("./images/1274_CareTeam_bio8.png")],
        },
        careTeam6: {
          index: 1,
          pages: [require("./images/1274_CareTeam_bio6.png")],
        },
        careTeam9: {
          index: 2,
          pages: [require("./images/1274_CareTeam_bio9.png")],
        },
        careTeam7: {
          index: 3,
          pages: [require("./images/1274_CareTeam_bio7.png")],
        },
      },
      oncologyPatient: {
        careTeam10: {
          index: 0,
          pages: [require("./images/1274_CareTeam_bio10.png")],
        },
        careTeam11: {
          index: 1,
          pages: [require("./images/1274_CareTeam_bio11.png")],
        },
        careTeam12: {
          index: 2,
          pages: [require("./images/1274_CareTeam_bio12.png")],
        },
      },
    },
    // textImage: require("./images/1274_elements_biographyfeedback.png"),
    textImage: require("./images/survey/1274_1210_elements_bio_provideFeedback.png"),
    arrowLeft: require("../common/images/Arrow_left.png"),
    arrowRight: require("../common/images/Arrow_right.png"),
    arrowUp: require("../common/images/Arrow_up.png"),
    arrowDown: require("../common/images/Arrow_down.png"),
    navigationBar: {
      back: true,
      backRoute: "/care_team/list",
      mainMenu: true,
      navigate: true,
    },
  };

  /*******************
   * Private methods *
   *******************/

  // get care team based on current patient
  getCareTeamList = () => {
    let careTeamList = null;
    switch (this.state.currentPatient) {
      case "orthoPatient":
        careTeamList = this.state.careTeamMembers.orthoPatient;
        break;
      case "chfPatient":
        careTeamList = this.state.careTeamMembers.chfPatient;
        break;
      case "pediatricPatient":
        careTeamList = this.state.careTeamMembers.pediatricPatient;
        break;
      case "oncologyPatient":
        careTeamList = this.state.careTeamMembers.oncologyPatient;
        break;
      default:
        careTeamList = this.state.careTeamMembers.default;
    }
    return careTeamList;
  };

  getCurrentPageIndex = () => {
    const currentCareTeamMmber = this.getCurrentCareMember();
    let pageNumber = this.props.match.params.page - 1;
    if (pageNumber < 0) {
      pageNumber = 0;
    } else if (pageNumber >= currentCareTeamMmber.pages.length) {
      pageNumber = currentCareTeamMmber.pages.length - 1;
    }
    return pageNumber;
  };

  getCurrentCareMember = () => {
    const careTeamList = this.getCareTeamList();
    return careTeamList[this.props.match.params.name];
  };

  getCareMember = (direction) => {
    const currentCareTeamMmber = this.getCurrentCareMember();
    const currentIndex = currentCareTeamMmber.index;
    const careTeamList = this.getCareTeamList();
    const index = (currentIndex + direction) % Object.keys(careTeamList).length;
    for (var key in careTeamList) {
      if (
        careTeamList.hasOwnProperty(key) &&
        careTeamList[key].index === index
      ) {
        return key;
      }
    }
    // Don't error out
    console.info(`CareTeamDetails::getCareMember() - Unknown`);
    return key;
  };

  getNextCareMember = () => {
    return this.getCareMember(1);
  };

  getPreviousCareMember = () => {
    return this.getCareMember(-1);
  };

  goToCareMember = (careTeamMember) => {
    this.props.history.push(`/care_team/details/${careTeamMember}/1`);
  };

  goToPage = (pageNumber) => {
    // multiple pages currently not used
    // const currentMember = this.props.careTeamMembers.match.params.name;

    // getting care team list based on current patient
    const careTeamList = this.getCareTeamList();
    const currentMember = careTeamList.match.params.name;
    this.props.history.push(
      `/care_team/details/${currentMember}/${pageNumber}`
    );
  };

  handlePageLeft = () => {
    const previousCareMember = this.getPreviousCareMember();
    this.goToCareMember(previousCareMember);
  };

  handlePageRight = () => {
    const nextCareMember = this.getNextCareMember();
    this.goToCareMember(nextCareMember);
  };

  handlePageUp = () => {
    const nextPageNumber = parseInt(this.props.match.params.page, 10) + 1;
    if (nextPageNumber <= this.getCurrentCareMember().pages.length) {
      this.goToPage(nextPageNumber);
    }
  };

  handlePageDown = () => {
    const nextPageNumber = parseInt(this.props.match.params.page, 10) - 1;
    if (nextPageNumber > 0) {
      this.goToPage(nextPageNumber);
    }
  };

  goToSurvey() {
    this.props.history.push(
      `/care_team/survey/${this.props.match.params.name}`
    );
  }

  handleOnKeyUp = (event) => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (event.key) {
      case "ArrowLeft":
        this.handlePageLeft();
        break;
      case "ArrowRight":
        this.handlePageRight();
        break;
      case "ArrowDown":
        this.handlePageUp();
        break;
      case "ArrowUp":
        this.handlePageDown();
        break;
      case "Enter":
        this.goToSurvey();
        break;
      default:
    }
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will add a listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener("keyup", this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for component that will unmount.
   *
   * This method will remove the listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleOnKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    const currentCareTeamMmber = this.getCurrentCareMember();
    const pageIndex = this.getCurrentPageIndex();
    return (
      <div className="care-team-detail">
        <ImageText id="text" src={this.state.textImage} />
        <img
          className="details"
          src={currentCareTeamMmber.pages[pageIndex]}
          alt=""
        />
        <div className="arrows">
          <img
            className="arrow-left"
            src={this.state.arrowLeft}
            alt=""
            onClick={this.handlePageLeft}
          />
          <img
            className="arrow-right"
            src={this.state.arrowRight}
            alt=""
            onClick={this.handlePageRight}
          />
        </div>
        {currentCareTeamMmber.pages.length > 1 && (
          <div className="arrows">
            <img className="arrow-up" src={this.state.arrowUp} alt="" />
            <img className="arrow-down" src={this.state.arrowDown} alt="" />
          </div>
        )}
        <NavigationBar {...this.state.navigationBar} />
        <button
          className="btn-feedback"
          onClick={() => this.goToSurvey()}
        ></button>
      </div>
    );
  }
}

const ConnectedCareTeamDetail = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(CareTeamDetail);

export default withRouter(ConnectedCareTeamDetail);
